import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { PageWrapper } from "~/components/page-wrapper";
import { TaxRatesSettings } from "~/components/settings/tax-rates-settings";
import { Skeleton } from "~/components/ui/skeleton";

export const Route = createFileRoute("/_authenticated/settings/tax-rates")({
  component: TaxRatesPage,
});

function TaxRatesPage() {
  return (
    <PageWrapper
      description="Manage sales tax rates for your restaurant locations"
      title="Tax Rates"
    >
      <Suspense fallback={<Skeleton className="h-full w-full" />}>
        <TaxRatesSettings />
      </Suspense>
    </PageWrapper>
  );
}
